import type { LoggerFactory } from '@amp/web-apps-logger';
import type { Jet } from '~/jet';
import {
    makeClickAction,
    makeDOMClickActionHandler,
    type ClickAction,
    type DOMClickActionHandler,
} from '@amp/web-apps-common';
import {
    type Action,
    type CompoundAction,
    isCompoundAction,
    isFlowAction,
    type OpenExternalURLAction,
} from '~/jet/models';

type NotSetup = () => never;
type ClickActionHandler = DOMClickActionHandler<Action>;

export let clickAction: NotSetup | ClickAction<Action> = () => {
    throw new Error('need to call setupClickAction');
};
export let handleClickAction: NotSetup | ClickActionHandler = () => {
    throw new Error('need to call setupHandleClickAction');
};

export function isCompoundFlowAction(
    action: Action | null,
): action is CompoundAction {
    return (
        isCompoundAction(action) &&
        (action as CompoundAction)?.subactions?.some((subaction) =>
            isFlowAction(subaction),
        )
    );
}

export function isCompoundExternalAction(
    action: Action | null,
): action is CompoundAction {
    return (
        isCompoundAction(action) &&
        (action as CompoundAction)?.subactions?.some((subaction) =>
            isExternalAction(subaction),
        )
    );
}

export function isExternalAction(
    action: Action | null,
): action is OpenExternalURLAction {
    const kind = action?.$kind;
    return kind === 'openExternalURLAction';
}

export function setupClickAction(jet: Jet, logger: LoggerFactory) {
    const log = logger.loggerFor('clickAction');
    clickAction = makeClickAction(jet, log, {
        isExternalAction,
        isCompoundExternalAction,
    });
    handleClickAction = makeDOMClickActionHandler(jet, log, {
        isExternalAction,
        isCompoundExternalAction,
    });
}
